import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { MapPinned, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { geocodeAddress } from '@/lib/googleMaps';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' });
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const GeocodeTool = () => {
  const [stats, setStats] = useState(null);
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState({ done: 0, failed: 0, total: 0 });

  const load = async () => {
    const res = await fetch(`${API}/admin/properties/ungeocoded`, { headers: authHeaders() });
    if (res.ok) setStats(await res.json());
  };
  useEffect(() => { load(); }, []);

  const run = async () => {
    if (!stats?.items?.length) return;
    setRunning(true);
    let done = 0, failed = 0;
    setProgress({ done, failed, total: stats.items.length });
    for (const p of stats.items) {
      try {
        const r = await geocodeAddress(`${p.address}, ${p.city}, ${p.state} ${p.pincode}, India`)
          || await geocodeAddress(`${p.city}, ${p.state}, India`);
        if (!r) throw new Error('no result');
        const res = await fetch(`${API}/admin/properties/${p.property_id}/geo`, {
          method: 'PATCH', headers: authHeaders(),
          body: JSON.stringify({ latitude: r.geometry.location.lat(), longitude: r.geometry.location.lng(), geo_source: 'admin_geocode' }),
        });
        if (!res.ok) throw new Error('save failed');
        done += 1;
      } catch {
        failed += 1;
      }
      setProgress({ done, failed, total: stats.items.length });
      await sleep(120);
    }
    toast.success(`Geocoded ${done} listings${failed ? `, ${failed} failed` : ''}`);
    setRunning(false);
    load();
  };

  return (
    <div className="bg-white rounded-sm border border-border/50 p-5 flex flex-wrap items-center justify-between gap-4" data-testid="geocode-tool">
      <div>
        <h3 className="font-semibold text-[#0F172A] flex items-center gap-2"><MapPinned className="h-4 w-4 text-[#D4AF37]" /> Map coordinates</h3>
        <p className="text-sm text-muted-foreground mt-1" data-testid="geocode-stats">
          {stats ? `${stats.total - stats.ungeocoded} of ${stats.total} active listings have a map pin · ${stats.ungeocoded} missing` : 'Loading…'}
        </p>
        {running && (
          <p className="text-xs text-muted-foreground mt-1" data-testid="geocode-progress">
            {progress.done + progress.failed}/{progress.total} processed · {progress.failed} failed
          </p>
        )}
      </div>
      <Button onClick={run} disabled={running || !stats?.ungeocoded} className="bg-[#0F172A] text-white hover:bg-[#1E293B]" data-testid="geocode-listings-btn">
        {running ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <MapPinned className="h-4 w-4 mr-2" />}
        {running ? 'Geocoding…' : 'Geocode missing listings'}
      </Button>
    </div>
  );
};
